import { useAppClippo } from '@/core';
import { useClippoBlobs } from '@/utils';
import { Space, Menu, Image } from 'antd';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import { useMemo } from 'react';

interface Props {
  floorplanId: string;
  homeId: string;
  onSave: (url: string) => any;
  imageBox?: any;
}

export function BaselineImageDropdownMenu(props: Props) {
  const { floorplanId, onSave, imageBox } = props;

  const clippoProps = useAppClippo({
    defer: false,
    ownerId: floorplanId,
    ownerType: 'FloorplanImage',
  });

  const { blobs } = useClippoBlobs(clippoProps);
  const homeBlobs = useClippoBlobs(imageBox);

  const menuItems: ItemType[] = useMemo(() => {
    const unitedBlobs = blobs.concat(homeBlobs.blobs);
    return unitedBlobs
      .sort((a, b) => a.fileName.localeCompare(b.fileName))
      .map((value) => ({
        key: value.id,
        label: (
          <Space direction="horizontal" onClick={() => onSave(value.blobURL)}>
            {value.blobURL ? (
              <Image
                width={70}
                height={70}
                src={value.blobURL}
                preview={{ visible: false, mask: '' }}
              />
            ) : (
              <Image width={70} height={70} className="--loading" />
            )}
            <span>{value.fileName}</span>
          </Space>
        ),
      }));
  }, [blobs, onSave, homeBlobs]);

  return <Menu items={menuItems} />;
}
